const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;

export const WatchlistService = (request) => {
  const base = BACKEND_URL;

  const listWatchlists = () => request(`${base}/watchlists`, {}, 'GET');
  const createWatchlist = (name) => request(`${base}/watchlists`, {}, 'POST', { name });
  const renameWatchlist = (id, name) => request(`${base}/watchlists/${id}`, {}, 'PUT', { name });
  const deleteWatchlist = (id) => request(`${base}/watchlists/${id}`, {}, 'DELETE');
  const listTickers = (id) => request(`${base}/watchlists/${id}/tickers`, {}, 'GET');
  const addTicker = (id, ticker) => request(`${base}/watchlists/${id}/tickers`, {}, 'POST', { ticker });
  const removeTicker = (id, ticker) => request(`${base}/watchlists/${id}/tickers/${encodeURIComponent(ticker)}`, {}, 'DELETE');
  const reorderTickers = (id, items) => request(`${base}/watchlists/${id}/tickers/reorder`, {}, 'PUT', { items });

  return {
    listWatchlists,
    createWatchlist,
    renameWatchlist,
    deleteWatchlist,
    listTickers,
    addTicker,
    removeTicker,
    reorderTickers,
  };
};

